"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setDefaultOptions } from "date-fns";
import { tr } from "date-fns/locale";
// Set default date-fns options on server side

import { PropsWithChildren, useState } from "react";

export default function LayoutProviders({ children }: PropsWithChildren) {
	// Initialize client side options
	setDefaultOptions({ locale: tr });
	const [client] = useState(new QueryClient());

	return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
